export class sksisUrls {
  // Geoserver
  geoserverBaseURL = 'https://geosis.sksis.ca/geoserver/dss/wms';
}
